// src/services/api/messageCenterShiftLeaderCommission.js
import { apiClient } from './base';

export const getShiftLeaderCommissionForMonth = async (month) => {
  try {
    const response = await apiClient.get('/message-center-shift-leader-commission', { params: { month } });
    return response.data;
  } catch (error) {
    throw error;
  }
};
